import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import * as L from 'leaflet';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { getAppTexts } from 'src/app/shared/i18n/app-text';
import { AppLanguage, LanguageService } from 'src/app/shared/services/language.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  BusByTicketResponseDTO,
  BusByTicketBusResponseBody,
  BusByTicketMultipleAreaResponseBody,
  BusByTicketEventoItemDTO,
  BusByTicketParkingSlotDTO,
  BusHorarioDTO,
  EventsbyvenueRequestDTO,
  ZoneByEventsRequestDTO,
  ResponseParkingDTO,
} from 'src/app/data/dto/EnclosuresDTO';
import {
  PurchasedCompleteItemDTO,
  BuyTicketDTO,
  AvailablePlacesRequestDTO,
} from 'src/app/data/dto/BuyTicketsDTO';
import { DetalleZonaRequestDTO } from 'src/app/data/dto/EventDTO';
import { GetPurchasedCompleteUseCase } from 'src/app/core/usecases/buyTickets/GetPurchasedCompleteUseCase';
import { AddBuyTicketUseCase } from 'src/app/core/usecases/buyTickets/AddBuyTicketUseCase';
import { AvailablePlaceUseCase } from 'src/app/core/usecases/buyTickets/AvailablePlaceUseCase';
import { AddToCartUseCase } from 'src/app/core/usecases/cart/AddToCartUseCase';
import { GetMyCartUseCase } from 'src/app/core/usecases/cart/GetMyCartUseCase';
import { ListCartUseCase } from 'src/app/core/usecases/cart/ListCartUseCase';
import { DeleteCartUseCase } from 'src/app/core/usecases/cart/DeleteCartUseCase';
import { EmptyCartUseCase } from 'src/app/core/usecases/cart/EmptyCartUseCase';
import { EventsByEnclosuresUseCase } from 'src/app/core/usecases/enclosures/EventsByEnclosuresUseCase';
import { ZoneByEventsUseCase } from 'src/app/core/usecases/enclosures/ZoneByEventsUseCase';
import { ZonaUseCase } from 'src/app/core/usecases/event/ZonaUseCase';
import { CartRequestDTO, Cart, DeleteCartRequestDTO, EmptyCartRequestDTO } from 'src/app/data/dto/CartDTO';
import { AuthService } from 'src/app/auth/service/auth.service';
import { EnclosuresService } from 'src/app/enclosures/services/enclosures.service';
import { MessagesService } from 'src/app/disclaimers/services/messages.service';
import { MessageDTO } from 'src/app/data/dto/MessagesDTO';
import { AlertDialogComponent } from 'src/app/shared/components/alert-dialog/alert-dialog.component';


export type MissingType = 'bus' | 'event' | 'both';

export interface IncompleteEventDisplay {
  item: PurchasedCompleteItemDTO;
  missingType: MissingType;
  missingLabel: string;
  ticketId: number | null;
}

@Component({
  selector: 'app-buying-tickets',
  templateUrl: './buying-tickets.component.html',
  styleUrls: ['./buying-tickets.component.scss'],
})
export class BuyingTicketsComponent implements OnInit, OnDestroy {
  @ViewChild('confirmModal') confirmModal: any;

  data: BusByTicketResponseDTO = null;
  isBusTicket = false;
  isMultipleArea = false;

  multipleAreaResponse: BusByTicketMultipleAreaResponseBody = null;
  selectedZona: BusHorarioDTO = null;
  selectedZonaCosto = 0;
  selectedZonaEventId: number = null;
  zonaConfirmed = false;
  selectedPersonCount = 1;

  // Alert state
  showIncompleteAlert = false;
  incompleteDisplayItems: IncompleteEventDisplay[] = [];
  userName = '';

  // Loading state after clicking Comprar
  loadingBusData = false;

  // Cart state
  viewCart = false;
  myCart: any[] = [];
  totalCart = 0;
  subtotal = 0;
  serviceCharge = 0;
  total = 0;
  titleModal = '';
  message = '';
  idCart: any;

  // ── Buy event inline mode ────────────────────────────────────
  buyEventMode = false;
  btEnclosureId: number = null;
  btArrayEvents: any[] = [];
  btSelectedCar: string = null;
  btSelectedCarIcon = 'fas fa-car';
  btSelectedEvent: any = null;
  btListZonas: ResponseParkingDTO[] = [];
  btSelectedZone: number = null;
  btSelectedZoneName = '';
  btIdZonaSelect: number = null;
  btIdEvent: number = null;
  btFechaExpiracion: any;
  btCosto: any;
  btDetailEvent: any[] = [];
  btDetailZonas: any[] = [];
  btLugaresDisponibles: any;
  btLoadingZones = false;
  btLoadingAddress = false;
  btSelectedZoneAddress = '';
  btSelectedZoneReference = '';
  btArrCart: any[] = [];
  btTerminos = false;
  btLoading = false;
  btPreloadedZonesMap: { [idEvento: number]: BusByTicketParkingSlotDTO[] } = {};
  btPreloadedZonesList: BusByTicketParkingSlotDTO[] = [];
  btPersonCount = 1;
  btIsFree = false;
  showErrorAlert = false;
  errorAlertMessage = '';
  busMessages: MessageDTO[] = [];

  // ── Recinto map ──────────────────────────────────────────
  btRecintoLat: string | null = null;
  btRecintoLng: string | null = null;
  btRecintoName = '';
  btRecintoColor = '#2564a4';
  private btMap: L.Map | null = null;
  private btZoneMarkersMap = new Map<number, L.CircleMarker>();

  readonly carTypes = [
    { name: 'Compacto', icon: 'fas fa-car' },
    { name: 'Sedán / Coupé', icon: 'fas fa-car-side' },
    { name: 'SUV', icon: 'fas fa-truck-pickup' },
    { name: 'Camioneta', icon: 'fas fa-truck' },
    { name: 'Híbrido / Eléctrico', icon: 'fas fa-bolt' },
  ];

  private hasNavData = false;
  private userId: number = null;
  currentLang: AppLanguage = 'es';

  get t() {
    return getAppTexts('buyingTickets', this.currentLang);
  }

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private getPurchasedCompleteUseCase: GetPurchasedCompleteUseCase,
    private authService: AuthService,
    private enclosuresService: EnclosuresService,
    private messagesService: MessagesService,
    private addBuyTicketUseCase: AddBuyTicketUseCase,
    private availablePlaceUseCase: AvailablePlaceUseCase,
    private addToCartUseCase: AddToCartUseCase,
    private getMyCartUseCase: GetMyCartUseCase,
    private listCartUseCase: ListCartUseCase,
    private deleteCartUseCase: DeleteCartUseCase,
    private emptyCartUseCase: EmptyCartUseCase,
    private eventsByEnclosuresUseCase: EventsByEnclosuresUseCase,
    private zoneByEventsUseCase: ZoneByEventsUseCase,
    private zonaUseCase: ZonaUseCase,
    private readonly languageService: LanguageService,
  ) {
    const nav = this.router.getCurrentNavigation();
    if (nav?.extras?.state?.['busByTicketData']) {
      this.data = nav.extras.state['busByTicketData'];
      this.hasNavData = true;
    }
  }

  ngOnInit(): void {
    this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });

    const currentUser = this.authService.currentUserValue;
    this.userName = currentUser?.response?.chrNombreUsuario || '';
    this.userId = Number(currentUser?.response?.intIDUsuario) || null;

    if (this.userId) {
      this.checkPurchasedComplete();
    } else if (!this.hasNavData) {
      this.router.navigate(['/user-tickets']);
    } else {
      this.loadNavData();
    }
  }

  private checkPurchasedComplete(): void {
    this.loadingBusData = true;
    this.getPurchasedCompleteUseCase.execute(this.userId).subscribe({
      next: (items) => {
        this.loadingBusData = false;
        const incomplete = items.filter((item) => !item.isComplete);
        if (incomplete.length > 0) {
          this.incompleteDisplayItems = incomplete
            .map((item) => this.buildDisplayItem(item))
            .sort((a, b) => b.item.idEvent - a.item.idEvent);
          this.showIncompleteAlert = true;
        } else if (this.hasNavData) {
          this.loadNavData();
        } else {
          this.router.navigate(['/user-tickets']);
        }
      },
      error: () => {
        this.loadingBusData = false;
        if (this.hasNavData) {
          this.loadNavData();
        } else {
          this.router.navigate(['/user-tickets']);
        }
      },
    });
  }

  private buildDisplayItem(item: PurchasedCompleteItemDTO): IncompleteEventDisplay {
    let missingType: MissingType;
    let missingLabel: string;
    let ticketId: number | null;

    if (item.isMultipleAreaComplete && !item.isBusComplete) {
      missingType = 'bus';
      missingLabel = this.t.missingBusTicket;
      ticketId = item.mainTicketIds?.[0] ?? null;
    } else if (!item.isMultipleAreaComplete && item.isBusComplete) {
      missingType = 'event';
      missingLabel = this.t.missingEventTicket;
      ticketId = item.busTicketIds?.[0] ?? null;
    } else {
      missingType = 'both';
      missingLabel = this.t.missingBothTickets;
      ticketId = item.mainTicketIds?.[0] ?? item.busTicketIds?.[0] ?? null;
    }

    return { item, missingType, missingLabel, ticketId };
  }

  private loadNavData(): void {
    if (!this.data) return;
    const response = this.data.response;
    this.isBusTicket = response.isBusTicket;
    this.isMultipleArea = response.multipleAreaTicket;
    this.busMessages = [];

    if (this.isBusTicket) {
      const busBody = response as BusByTicketBusResponseBody;
      this.btEnclosureId = busBody.recinto?.idRecinto ?? null;
      this.btRecintoLat = busBody.recinto?.latitude ?? null;
      this.btRecintoLng = busBody.recinto?.longitude ?? null;
      this.btRecintoName = busBody.recinto?.chrNombreRecinto ?? '';
      this.btRecintoColor = busBody.recinto?.color || '#2564a4';
      this.btIsFree = busBody.recinto?.isFree ?? false;
      this.btPreloadedZonesMap = {};
      this.btArrayEvents = (busBody.recinto?.eventos ?? []).map((ev) => {
        this.btPreloadedZonesMap[ev.idEvento] = ev.zonas;
        return {
          intIDEvento: ev.idEvento,
          chrNombreEvento: ev.chrNombreEvento,
          chrTipoEvento: '',
          diaEventoAt: ev.dateEvent ?? ev.diaEventoAt ?? null,
        };
      });
      this.btSelectedCar = null;
      this.btSelectedEvent = null;
      this.btListZonas = [];
      this.btPreloadedZonesList = [];
      this.btSelectedZone = null;
      this.btDetailEvent = [];
      this.btDetailZonas = [];
      this.btTerminos = false;
      this.buyEventMode = true;
    } else {
      this.multipleAreaResponse = response as BusByTicketMultipleAreaResponseBody;
      this.selectedPersonCount = this.multipleAreaResponse.numberPerson;
      this.loadBusMessages();
    }
  }

  private loadBusMessages(): void {
    this.messagesService.getMessages('tickets').subscribe({
      next: (res) => {
        this.busMessages = res.response.filter(
          (m) => m.active && (m.platform === 'All' || m.platform === 'Web') && m.messageName === 'Ticket_Autobus',
        );
      },
      error: () => {
        this.busMessages = [];
      },
    });
  }

  getLocalizedMessageText(msg: MessageDTO): string {
    return this.currentLang === 'en'
      ? (msg.messageTextEn || msg.messageText)
      : msg.messageText;
  }

  incrementPersonCount(): void {
    this.selectedPersonCount++;
  }

  decrementPersonCount(): void {
    if (this.selectedPersonCount > 1) {
      this.selectedPersonCount--;
    }
  }

  clampPersonCount(): void {
    if (this.selectedPersonCount < 1) this.selectedPersonCount = 1;
  }

  get selectedBusPrice(): number {
    return Number(this.selectedZonaCosto) || 0;
  }

  get selectedBusTotal(): number {
    return this.selectedBusPrice * (this.selectedPersonCount || 1);
  }

  btIncrementPersonCount(): void { this.btPersonCount++; }
  btDecrementPersonCount(): void { if (this.btPersonCount > 1) this.btPersonCount--; }
  btClampPersonCount(): void { if (this.btPersonCount < 1) this.btPersonCount = 1; }

  onAlertBuy(display: IncompleteEventDisplay, forceType?: MissingType): void {
    const effectiveType = forceType ?? display.missingType;
    let ticketId: number | null;
    if (forceType === 'bus') {
      ticketId = display.item.mainTicketIds?.[0] ?? null;
    } else if (forceType === 'event') {
      ticketId = display.item.busTicketIds?.[0] ?? null;
    } else {
      ticketId = display.ticketId;
    }

    if (!ticketId) {
      this.showIncompleteAlert = false;
      return;
    }

    const effectiveDisplay = forceType ? { ...display, missingType: effectiveType, ticketId } : display;

    this.loadingBusData = true;
    this.enclosuresService.getBusesByTicket(ticketId).subscribe({
      next: (data) => {
        this.loadingBusData = false;
        this.showIncompleteAlert = false;
        this.zonaConfirmed = false;
        const response = data.response;
        this.isBusTicket = response.isBusTicket;
        this.isMultipleArea = response.multipleAreaTicket;

        if (effectiveDisplay.missingType === 'event') {
          let eventos: BusByTicketEventoItemDTO[] = [];
          let enclosureId = effectiveDisplay.item.idEnclosure;
          let lat: string | null = null;
          let lng: string | null = null;
          let recintoName = '';
          let recintoColor = '#2564a4';
          let isFree = false;

          if (this.isBusTicket) {
            const busBody = response as BusByTicketBusResponseBody;
            enclosureId = busBody.recinto?.idRecinto ?? enclosureId;
            lat = busBody.recinto?.latitude ?? null;
            lng = busBody.recinto?.longitude ?? null;
            recintoName = busBody.recinto?.chrNombreRecinto ?? '';
            recintoColor = busBody.recinto?.color || '#2564a4';
            isFree = busBody.recinto?.isFree ?? false;
            eventos = busBody.recinto?.eventos ?? [];
          } else {
            // multipleArea response: no tiene datos de recinto, usamos lo del item
            enclosureId = effectiveDisplay.item.idEnclosure;
          }

          this.btEnclosureId = enclosureId;
          this.btRecintoLat = lat;
          this.btRecintoLng = lng;
          this.btRecintoName = recintoName;
          this.btRecintoColor = recintoColor;
          this.btPreloadedZonesMap = {};
          this.btArrayEvents = eventos.map((ev) => {
            this.btPreloadedZonesMap[ev.idEvento] = ev.zonas;
            return {
              intIDEvento: ev.idEvento,
              chrNombreEvento: ev.chrNombreEvento,
              chrTipoEvento: '',
              diaEventoAt: ev.dateEvent ?? ev.diaEventoAt ?? null,
            };
          });
          this.btSelectedCar = null;
          this.btSelectedEvent = null;
          this.btListZonas = [];
          this.btPreloadedZonesList = [];
          this.btSelectedZone = null;
          this.btDetailEvent = [];
          this.btDetailZonas = [];
          this.btTerminos = false;
          this.btIsFree = isFree;
          this.buyEventMode = true;
          return;
        }

        this.btIsFree = false;
        this.multipleAreaResponse = response as BusByTicketMultipleAreaResponseBody;
        this.selectedZona = null;
        this.selectedZonaCosto = 0;
        this.selectedPersonCount = this.multipleAreaResponse.numberPerson;
        this.loadBusMessages();
      },
      error: () => {
        this.loadingBusData = false;
        this.showIncompleteAlert = false;
      },
    });
  }

  onAlertCancel(): void {
    this.showIncompleteAlert = false;
    this.router.navigate(['/user-tickets']);
  }

  // ── Buy event inline: load events ───────────────────────────
  btLoadEvents(): void {
    this.loadingBusData = true;
    const request: EventsbyvenueRequestDTO = { id: this.btEnclosureId };
    this.eventsByEnclosuresUseCase.execute(request).subscribe({
      next: (data) => {
        this.loadingBusData = false;
        this.btArrayEvents = data.response
          .filter((e: any) => !e.ticketAccessUnLimit)
          .map((e: any) => ({
            intIDEvento: e.intIDEvento,
            chrNombreEvento: e.chrNombreEvento,
            chrTipoEvento: e.chrTipoEvento,
            diaEventoAt: e.diaEventoAt,
          }));
      },
      error: () => { this.loadingBusData = false; },
    });
  }

  // ── Buy event inline: select car ────────────────────────────
  btSelectCar(car: string): void {
    this.btSelectedCar = car;
    const found = this.carTypes.find((c) => c.name === car);
    if (found) this.btSelectedCarIcon = found.icon;
  }

  // ── Buy event inline: select event ──────────────────────────
  btSelectEvento(evento: any): void {
    this.btSelectedEvent = evento;
    this.btSelectedZone = null;
    this.btSelectedZoneName = '';
    this.btListZonas = [];
    this.btDetailZonas = [];
    this.btDetailEvent = [];
    if (evento) {
      this.btIdEvent = evento.intIDEvento;
      this.btFechaExpiracion = evento.diaEventoAt;
      this.btDetailEvent = [{ Evento: evento.chrTipoEvento, Fecha: evento.diaEventoAt }];
      if (this.btPreloadedZonesMap[evento.intIDEvento]?.length) {
        this.btPreloadedZonesList = this.btPreloadedZonesMap[evento.intIDEvento];
      } else {
        this.btGetListZones();
      }
      setTimeout(() => this.btInitMap(), 150);
    } else {
      this.btDestroyMap();
    }
  }

  // ── Buy event inline: load zones ────────────────────────────
  btGetListZones(): void {
    this.btLoadingZones = true;
    this.btListZonas = [];
    const request: ZoneByEventsRequestDTO = { id: this.btIdEvent };
    this.zoneByEventsUseCase.execute(request).subscribe({
      next: (data) => {
        if (data.responseParking?.length && 'intIDZonaEstacionamiento' in data.responseParking[0]) {
          this.btListZonas = data.responseParking;
        }
        this.btLoadingZones = false;
        this.btAddZoneMarkers();
      },
      error: () => { this.btLoadingZones = false; },
    });
  }

  // ── Buy event inline: select zone ───────────────────────────
  btSelectZone(idZona: number, nameZona: string): void {
    this.btSelectedZone = idZona;
    this.btSelectedZoneName = nameZona;
    this.btPersonCount = 1;
    this.btDetailZonas = [];
    this.btLoadingAddress = true;
    this.btSelectedZoneAddress = '';
    this.btSelectedZoneReference = '';

    const zona = this.btListZonas.find((z) => z.tblZona.idZona === idZona);
    if (zona) {
      this.btIdZonaSelect = zona.intIDZonaEstacionamiento;
      this.btCosto = zona.price;
      this.btDetailZonas = [{ Costo: zona.fltPrecioZona }];
      this.btSelectedZoneReference = (zona.tblZona as any)?.reference || '';
      this.btZoneMarkersMap.get(zona.intIDZonaEstacionamiento)?.openPopup();
    }

    const request: DetalleZonaRequestDTO = { id: this.btIdZonaSelect };
    this.zonaUseCase.execute(request).subscribe({
      next: (data) => {
        this.btLugaresDisponibles = data.response.restOfPlaces;
        this.btSelectedZoneAddress = data.response.address;
        this.btLoadingAddress = false;
      },
      error: () => { this.btLoadingAddress = false; },
    });
  }

  // ── Buy event inline: select preloaded zone (from bus response) ─
  btSelectPreloadedZone(zona: BusByTicketParkingSlotDTO): void {
    this.btSelectedZone = zona.idZonaEstacionamiento;
    this.btSelectedZoneName = zona.chrNombreZona;
    this.btPersonCount = 1;
    this.btIdZonaSelect = zona.idZonaEstacionamiento;
    this.btCosto = zona.price ?? zona.precioZona;
    this.btDetailZonas = [{ Costo: zona.precioZona }];
    this.btLoadingAddress = true;
    this.btSelectedZoneAddress = '';
    this.btSelectedZoneReference = '';
    this.btZoneMarkersMap.get(zona.idZonaEstacionamiento)?.openPopup();
    const request: DetalleZonaRequestDTO = { id: zona.idZonaEstacionamiento };
    this.zonaUseCase.execute(request).subscribe({
      next: (data) => {
        this.btLugaresDisponibles = data.response.restOfPlaces;
        this.btSelectedZoneAddress = data.response.address;
        this.btLoadingAddress = false;
      },
      error: () => { this.btLoadingAddress = false; },
    });
  }

  // ── Buy event inline: add to cart ───────────────────────────
  btCart(): void {
    if (!this.btSelectedCar || !this.btSelectedEvent || !this.btSelectedZone || !this.btTerminos) return;
    if (this.btLugaresDisponibles === 0) return;

    this.btLoading = true;
    const ticketBase: BuyTicketDTO = {
      idUsuario: this.userId,
      idEvento: this.btIdEvent,
      idZonaEstacionamiento: this.btIdZonaSelect,
      fechaExpiracionAt: this.btFechaExpiracion,
      bolActiveQR: true,
      costoTotal: this.btCosto,
      blnPagado: false,
      cantidad: 1,
      typeCar: this.btSelectedCar,
      numberPerson: this.btPersonCount,
    };

    this.addBuyTicketUseCase.execute(ticketBase).subscribe({
      next: (data) => {
        if ((data as any).result === 'error') {
          this.btLoading = false;
          this.errorAlertMessage = (data as any).message || this.t.genericError;
          this.showErrorAlert = true;
          return;
        }
        const responses = Array.isArray(data.response) ? data.response : [data.response];
        const ticketIds = responses
          .filter((t: any) => t?.intFolioBoleto)
          .map((t: any) => t.intFolioBoleto)
          .join(',');
        const totalCost = responses.reduce(
          (sum: number, t: any) => sum + (Number(t?.costoTotal) || 0),
          0,
        );

        if (this.btIsFree) {
          this.btLoading = false;
          this.titleModal = this.t.ticketAcquiredTitle;
          this.message = this.t.eventTicketGeneratedSuccess;
          this.showConfirm();
          return;
        }

        const availReq: AvailablePlacesRequestDTO = {
          id: this.btIdEvent,
          ticket: String(responses[0]?.intFolioBoleto),
        };
        this.availablePlaceUseCase.execute(availReq).subscribe();

        const cartReq: CartRequestDTO = {
          intFKIdBuyTickets: ticketIds,
          cost: String(totalCost),
          intFKIdUser: this.userId,
          isPaid: false,
          intFKIdPaymentStatus: 8,
        };

        this.addToCartUseCase.execute(cartReq).subscribe({
          next: () => {
            this.btLoading = false;
            this.titleModal = this.t.cartAddedTitle;
            this.message = this.t.cartAddedMessage;
            this.showConfirm();
          },
          error: () => { this.btLoading = false; },
        });
      },
      error: (err) => {
        this.btLoading = false;
        if (err?.message) {
          this.errorAlertMessage = err.message;
          this.showErrorAlert = true;
        }
      },
    });
  }

  btCancel(): void {
    this.btDestroyMap();
    this.buyEventMode = false;
    this.btIsFree = false;
    this.btPreloadedZonesMap = {};
    this.btPreloadedZonesList = [];
    this.router.navigate(['/home']);
  }

  ngOnDestroy(): void {
    this.btDestroyMap();
  }

  private btDestroyMap(): void {
    this.btZoneMarkersMap.forEach((m) => m.remove());
    this.btZoneMarkersMap.clear();
    if (this.btMap) {
      this.btMap.remove();
      this.btMap = null;
    }
  }

  btInitMap(): void {
    this.btDestroyMap();
    const lat = parseFloat(this.btRecintoLat || '');
    const lng = parseFloat(this.btRecintoLng || '');
    if (isNaN(lat) || isNaN(lng)) return;

    this.btMap = L.map('bt-recinto-map').setView([lat, lng], 15);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
    }).addTo(this.btMap);

    const recintoIcon = L.divIcon({
      className: '',
      html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 48" width="32" height="48">
        <path d="M16 0C7.163 0 0 7.163 0 16c0 11.314 16 32 16 32S32 27.314 32 16C32 7.163 24.837 0 16 0z"
          fill="${this.btRecintoColor}" stroke="#031e3a" stroke-width="1.5"/>
        <circle cx="16" cy="16" r="6" fill="#fff"/>
        <circle cx="16" cy="16" r="3" fill="#031e3a"/>
      </svg>`,
      iconSize: [32, 48],
      iconAnchor: [16, 48],
      popupAnchor: [0, -48],
    });

    L.marker([lat, lng], { icon: recintoIcon })
      .addTo(this.btMap)
      .bindPopup(this.btRecintoName)
      .openPopup();

    this.btAddZoneMarkers();
  }

  private btAddZoneMarkers(): void {
    if (!this.btMap) return;

    this.btZoneMarkersMap.forEach((m) => m.remove());
    this.btZoneMarkersMap.clear();

    const zones =
      this.btPreloadedZonesList.length > 0
        ? this.btPreloadedZonesList.map((z) => ({ id: z.idZonaEstacionamiento, lat: z.latitude, lng: z.longitude, name: z.chrNombreZona }))
        : this.btListZonas.map((z) => ({ id: z.intIDZonaEstacionamiento, lat: z.latitude, lng: z.longitude, name: z.nameZona }));

    zones.forEach((z) => {
      const zLat = parseFloat(z.lat || '');
      const zLng = parseFloat(z.lng || '');
      if (isNaN(zLat) || isNaN(zLng)) return;

      const marker = L.circleMarker([zLat, zLng], {
        radius: 10,
        fillColor: this.btRecintoColor,
        color: '#fff',
        weight: 2,
        opacity: 1,
        fillOpacity: 0.9,
      })
        .addTo(this.btMap)
        .bindPopup(z.name);

      this.btZoneMarkersMap.set(z.id, marker);
    });
  }

  // ── Bus/MultipleArea flow ────────────────────────────────────
  selectZona(horario: BusHorarioDTO): void {
    this.selectedZona = horario;
    this.selectedPersonCount = this.multipleAreaResponse?.numberPerson ?? 1;
    const hasPrice = horario.price !== undefined && horario.price !== null;
    if (hasPrice) {
      this.selectedZonaCosto = Number(horario.price) || 0;
      this.selectedZonaEventId = horario.idEvent ?? null;
      return;
    }
    this.selectedZonaCosto = 0;
    this.selectedZonaEventId = null;
    const req: DetalleZonaRequestDTO = { id: horario.id };
    this.zonaUseCase.execute(req).subscribe({
      next: (data) => {
        if (this.selectedZona && this.selectedZona.id === horario.id) {
          this.selectedZonaCosto = data.response?.price ? data.response.precioZona : 0;
          this.selectedZonaEventId = data.response?.intEventos_intIDEvento ?? null;
        }
      },
    });
  }

  onConfirmZona(): void {
    if (!this.selectedZona) return;
    this.btIsFree = false;
    this.loadingBusData = true;

    const fechaExp = new Date();
    fechaExp.setDate(fechaExp.getDate() + 1);

    const ticketBase: BuyTicketDTO = {
      idUsuario: this.userId,
      idEvento: this.selectedZonaEventId ?? this.multipleAreaResponse.idEvent,
      idZonaEstacionamiento: this.selectedZona.id,
      fechaExpiracionAt: fechaExp,
      bolActiveQR: true,
      costoTotal: this.selectedZonaCosto,
      blnPagado: false,
      cantidad: 1,
      typeCar: 'Autobús',
      numberPerson: this.selectedPersonCount,
      conEstacionamiento: true,
    };

    const requests = Array.from({ length: this.selectedPersonCount }, () =>
      this.addBuyTicketUseCase.execute({ ...ticketBase }),
    );

    forkJoin(requests).subscribe({
      next: (results: any[]) => {
        const errorResult = results.find((data: any) => data?.result === 'error');
        if (errorResult) {
          this.loadingBusData = false;
          this.errorAlertMessage = errorResult.message || this.t.ticketAcquireError;
          this.showErrorAlert = true;
          return;
        }

        const allTickets = ([] as any[])
          .concat(...results.map((data: any) => Array.isArray(data.response) ? data.response : [data.response]))
          .filter((t: any) => t?.intFolioBoleto);

        if (!allTickets.length) {
          this.loadingBusData = false;
          this.errorAlertMessage = this.t.ticketsCreationError;
          this.showErrorAlert = true;
          return;
        }

        const ticketIds = allTickets.map((t: any) => t.intFolioBoleto).join(',');
        const totalCost = allTickets.reduce(
          (sum: number, t: any) => sum + (Number(t?.costoTotal) || 0),
          0,
        ) || (this.selectedZonaCosto * this.selectedPersonCount);

        const cartReq: CartRequestDTO = {
          intFKIdBuyTickets: ticketIds,
          cost: String(totalCost),
          intFKIdUser: this.userId,
          isPaid: false,
          intFKIdPaymentStatus: 8,
        };

        this.addToCartUseCase.execute(cartReq).subscribe({
          next: () => {
            this.loadingBusData = false;
            this.titleModal = this.t.cartAddedTitle;
            this.message = this.t.cartAddedMessage;
            this.showConfirm();
          },
          error: () => { this.loadingBusData = false; },
        });
      },
      error: (err: any) => {
        this.loadingBusData = false;
        this.errorAlertMessage = err?.message || this.t.ticketAcquireError;
        this.showErrorAlert = true;
      },
    });
  }

  showConfirm(): void {
    this.modalService.open(this.confirmModal, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      windowClass: 'bt-cart-confirm-modal-window',
    });
  }

  onModalAccept(): void {
    this.modalService.dismissAll();
    if (this.btIsFree) {
      this.router.navigate(['/user-tickets']);
    } else {
      this.viewCart = true;
      document.body.classList.add('cart-open');
      this.onCart();
    }
  }

  get groupedCart(): any[] {
    const ida = this.myCart.find((item: any) => item.typeTicket === 'Ida');
    const vuelta = this.myCart.find((item: any) => item.typeTicket === 'Vuelta');
    const others = this.myCart.filter((item: any) => item.typeTicket !== 'Ida' && item.typeTicket !== 'Vuelta');
    const result: any[] = [];
    if (ida && vuelta) {
      result.push({ ...ida, isRoundTrip: true, zonePrice: ida.zonePrice + vuelta.zonePrice, vueltaItem: vuelta, ticketCount: 2 });
    } else {
      if (ida) result.push(ida);
      if (vuelta) result.push(vuelta);
    }
    return [...result, ...others];
  }

  private resolveUserId(): number | null {
    if (this.userId) {
      return this.userId;
    }

    const currentUser = this.authService.currentUserValue;
    this.userId = Number(currentUser?.response?.intIDUsuario) || null;
    return this.userId;
  }

  private showCartActionError(error: any, fallbackMessage: string): void {
    this.loadingBusData = false;
    this.errorAlertMessage = error?.message || fallbackMessage;
    this.showErrorAlert = true;
  }

  private resetCartState(): void {
    this.viewCart = false;
    this.myCart = [];
    this.totalCart = 0;
    this.subtotal = 0;
    this.serviceCharge = 0;
    this.total = 0;
    this.idCart = null;
    document.body.classList.remove('cart-open');
  }

  private getRemoveCartMessage(element: any): string {
    const eventSuffix = element?.event ? ` de "${element.event}"` : '';

    if (element?.isRoundTrip) {
      return this.t.removeRoundTripMessage.replace('{event}', eventSuffix);
    }

    return this.t.removeSingleMessage.replace('{event}', eventSuffix);
  }

  private executeCartRemoval(element: any): void {
    if (element?.isRoundTrip) {
      this.onRemoveRoundTrip(element, element.vueltaItem);
      return;
    }

    this.onRemoveFromCart(element);
  }

  confirmRemoveFromCart(event: Event, element: any): void {
    event.preventDefault();
    event.stopPropagation();

    const modalRef = this.modalService.open(AlertDialogComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });

    modalRef.componentInstance.title = element?.isRoundTrip ? this.t.removeTicketsTitle : this.t.removeTicketTitle;
    modalRef.componentInstance.message = this.getRemoveCartMessage(element);
    modalRef.componentInstance.type = 'warning';
    modalRef.componentInstance.buttons = [
      {
        text: this.t.keepButton,
        cssClass: 'btn-secondary',
        emitValue: 'cancel',
        icon: 'fas fa-arrow-left',
      },
      {
        text: this.t.deleteButton,
        cssClass: 'btn-danger',
        emitValue: 'accept',
        icon: 'far fa-trash-alt',
      },
    ];

    modalRef.componentInstance.buttonClick.subscribe((result: string) => {
      modalRef.close();

      if (result === 'accept') {
        this.executeCartRemoval(element);
      }
    });
  }

  onRemoveRoundTrip(idaItem: any, vueltaItem: any): void {
    if (this.totalCart === 2) {
      if (!idaItem?.idCart) {
        this.showCartActionError(null, this.t.cartNotFoundError);
        return;
      }

      const req: EmptyCartRequestDTO = { idTicket: idaItem.idCart };
      this.emptyCartUseCase.execute(req).subscribe({
        next: () => {
          this.resetCartState();
        },
        error: (error) => {
          this.showCartActionError(error, this.t.emptyCartError);
        },
      });
    } else {
      const resolvedUserId = this.resolveUserId();
      if (!resolvedUserId) {
        this.showCartActionError(null, this.t.cartUserNotFoundError);
        return;
      }
      if (!idaItem?.id || !vueltaItem?.id) {
        this.showCartActionError(null, this.t.cartTicketsNotFoundError);
        return;
      }

      const reqIda: DeleteCartRequestDTO = { idUser: resolvedUserId, idTicket: idaItem.id };
      this.deleteCartUseCase.execute(reqIda).subscribe({
        next: () => {
          const reqVuelta: DeleteCartRequestDTO = { idUser: resolvedUserId, idTicket: vueltaItem.id };
          this.deleteCartUseCase.execute(reqVuelta).subscribe({
            next: () => this.onCart(),
            error: (error) => {
              this.showCartActionError(error, this.t.deleteReturnTicketError);
            },
          });
        },
        error: (error) => {
          this.showCartActionError(error, this.t.deleteDepartureTicketError);
        },
      });
    }
  }

  onToggleCart(): void {
    this.modalService.dismissAll();
    this.viewCart = !this.viewCart;
    document.body.classList.toggle('cart-open', this.viewCart);
    if (this.viewCart) {
      this.onCart();
    }
  }

  onCart(): void {
    const resolvedUserId = this.resolveUserId();
    if (!resolvedUserId) {
      this.showCartActionError(null, this.t.loadCartUserMissingError);
      return;
    }

    this.loadingBusData = true;
    this.myCart = [];
    const request: Cart = { id: resolvedUserId };
    this.listCartUseCase.execute(request).subscribe({
      next: (response) => {
        this.loadingBusData = false;
        let tot = 0;
        let subTotal = 0;
        let cargo = 0;
        if (response.response) {
          this.myCart = response.response as any[];
          this.totalCart = this.myCart.length;
          this.myCart.forEach((element) => {
            this.idCart = element.idCart;
            subTotal += Number(element.zonePrice);
            cargo += Number(element.charge);
            tot += Number(element.price);
          });
        }
        this.subtotal = subTotal;
        this.serviceCharge = cargo;
        this.total = tot;
      },
      error: () => {
        this.loadingBusData = false;
      },
    });
  }

  onPayment(): void {
    const idAdmin = localStorage.getItem('idAdmin');
    this.router.navigate(['/card-payment', this.idCart, { idAdmin }]);
  }

  onRemoveFromCart(element: any): void {
    if (this.totalCart === 1) {
      if (!element?.idCart) {
        this.showCartActionError(null, this.t.cartNotFoundError);
        return;
      }

      const req: EmptyCartRequestDTO = { idTicket: element.idCart };
      this.emptyCartUseCase.execute(req).subscribe({
        next: () => {
          this.resetCartState();
        },
        error: (error) => {
          this.showCartActionError(error, this.t.emptyCartError);
        },
      });
    } else {
      const resolvedUserId = this.resolveUserId();
      if (!resolvedUserId) {
        this.showCartActionError(null, this.t.cartUserNotFoundError);
        return;
      }
      if (!element?.id) {
        this.showCartActionError(null, this.t.singleTicketToDeleteError);
        return;
      }

      const req: DeleteCartRequestDTO = { idUser: resolvedUserId, idTicket: element.id };
      this.deleteCartUseCase.execute(req).subscribe({
        next: () => this.onCart(),
        error: (error) => {
          this.showCartActionError(error, this.t.deleteTicketError);
        },
      });
    }
  }

  getImageUrl(raw: string): string {
    const str = raw ? String(raw).trim() : '';
    if (str && str.toUpperCase() !== 'N/A') {
      return str.startsWith('http')
        ? str
        : this.enclosuresService.buildFileExampleDownloadUrl(str);
    }
    return 'assets/img/parkit-logo.png';
  }

  onUserTickets(): void {
    this.router.navigate(['/user-tickets']);
  }

  onHome(): void {
    this.router.navigate(['/home']);
  }
}
